import { createSlice } from '@reduxjs/toolkit'
import {
  getTaskComments,
  saveTaskComment,
  createTaskComment,
  deleteTaskComment,
} from './taskCommentActions'

const initialState = {
  taskComments: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedTaskComment: {},
  deleting: false,
  deleted: false,
  deletingError: false,
  loaded: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const taskCommentsSlice = createSlice({
  name: 'taskComments',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedTaskComment = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
      state.loaded = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getTaskComments.fulfilled, (state, { payload }) => {
        state.loading = false
        state.taskComments = payload
        state.loaded = true
      })
      .addCase(getTaskComments.pending, (state) => {
        state.loading = true
        state.error = null
        state.loaded = false
      })
      .addCase(saveTaskComment.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveTaskComment.fulfilled, (state, { payload }) => {
        state.savingError = null
        //state.taskComments[state.taskComments.findIndex((p) => p.id === payload.id)] = payload
        state.savedTaskComment = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveTaskComment.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createTaskComment.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createTaskComment.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedTaskComment = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createTaskComment.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteTaskComment.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteTaskComment.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteTaskComment.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
          state.loaded = false
        },
      )
  },
})
export const { clear } = taskCommentsSlice.actions
export default taskCommentsSlice.reducer
